import {
  withExport,
  withResourceState,
} from '@kinet-open-network/client/shared/data-access/state';
import { signalStore } from '@ngrx/signals';
import { AdditionalServicesService } from '../services/additional-services.service';

export const AdditionalServicesStore = signalStore(
  { protectedState: false },
  withResourceState(AdditionalServicesService),
  withExport(AdditionalServicesService),
);
